import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Spinner } from '@wellbeingxltd/fe-lib/components'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import { useSupplierProfile } from 'hooks/useSupplierProfile'
import { isAllowedRoute } from 'helpers/isAllowedRoute'
import { getAllButtons } from './buttonsConfig'
import Button from './Button'
import './styles.scss'

const allButtons = getAllButtons()

export const Sidebar = () => {
    const history = useHistory()
    const [buttons, setButtons] = useState([])
    const { loadingManagers: loading } = useSelector(GET_STORE.MANAGERS)
    const { accessToPages } = useSupplierProfile()

    const memorizedAccessToPages = useMemo(() => accessToPages, [accessToPages])

    useEffect(() => {
        if (memorizedAccessToPages) {
            const allowedButtons = allButtons.filter(({ value }) => isAllowedRoute({ key: value, accessToPages: memorizedAccessToPages }))
            setButtons(allowedButtons)
        } else {
            setButtons(allButtons)
        }
    }, [memorizedAccessToPages])

    return (
        <div className="sidebar">
            {loading ? (
                <Spinner color="var(--blue)" style={{ display: 'flex', justifyContent: 'center', height: 100 }} />
            ) : (
                buttons.map(({ title, link, Icon, size }, key) => (
                    <Button
                        title={title}
                        key={key}
                        Icon={Icon}
                        selected={link === window.location.pathname}
                        size={size}
                        onClick={() => history.push(link)}
                    />
                ))
            )}
        </div>
    )
}
